// modernEngagementCard.jsx
import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box,
  Avatar,
} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export default function ModernEngagementCard({ engagement }) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  if (!engagement.value || engagement.value === 0 || engagement.value === 'N/A') {
    return null;
  }

  const formatValue = (val) => {
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    return val;
  };

  return (
    <Card 
      elevation={0}
      sx={{ 
        height: '100%',
        borderRadius: 3,
        border: `1px solid ${isDarkMode ? '#2A2A2A' : '#E5E7EB'}`,
        backgroundColor: isDarkMode ? '#1A1A1A' : '#FFFFFF',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: isDarkMode
            ? '0 8px 20px rgba(0,0,0,0.3)'
            : '0 8px 20px rgba(15,23,42,0.06)',
        }
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <Avatar
            sx={{
              width: 34,
              height: 34,
              backgroundColor: isDarkMode ? 'rgba(255,255,255,0.06)' : '#F3F4F6',
              color: isDarkMode ? '#D1D5DB' : '#6B7280',
              mr: 2,
            }}
          >
            {React.cloneElement(engagement.icon, { sx: { fontSize: 16 } })}
          </Avatar>
          <Typography 
            variant="body2" 
            color="text.secondary"
            fontWeight={600}
            sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.68rem' }}
          >
            {engagement.label}
          </Typography>
        </Box>
        <Typography 
          variant="h5"
          fontWeight={800}
          color={isDarkMode ? '#FFFFFF' : '#111827'}
          sx={{ fontSize: { xs: '1.4rem', md: '1.7rem' } }}
        >
          {formatValue(engagement.value)}
        </Typography>
      </CardContent>
    </Card>
  );
}
